import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';

import Tooltip from '@material-ui/core/Tooltip';
import { AppStyles } from '../styles/AppTheme';

export class AppHelper {
  static buttonEdit(caller, current) {
    return(
      <Tooltip title='Edit' placement='top-start' key={current.id + 'editTT'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons' onClick={() => caller.openModalForEdit(current)}>edit</i>
        </span>
      </Tooltip>
    )
  }

  static buttonDelete(caller, current) {
    return(
      <Tooltip title='Delete' placement='top-start' key={current.id + 'deleteTT'}>
        <span className={css(AppStyles.entityTableLinkIcon)}>
          <i className='material-icons' onClick={() => caller.openModalForDelete(current)}>delete</i>
        </span>
      </Tooltip>
    )
  }

  static getPriorityStr = (priority) => {
    let priorityStr = '';
    if (priority === 0) {
      priorityStr = 'Very low'
    }
    else if (priority === 1) {
      priorityStr = 'Low'
    }
    else if (priority === 2) {
      priorityStr = 'Medium'
    }
    else if (priority === 3) {
      priorityStr = 'High'
    }
    return priorityStr;
  }

  static getPriotiyColor = (priority) => {
    let backgroundColor = 'green';
    if(priority === 0 ) {
      backgroundColor = 'green'
    }
    else if(priority === 1 ) {
      backgroundColor = '#d0d000'
    }
    else if(priority === 2 ) {
      backgroundColor = 'orange'
    }
    else if(priority === 3 ) {
      backgroundColor = 'red'
    }
    return backgroundColor;
  }

  static arrayToCsv(items) {
    //return items
    if(!items) return null
    let csv = ''
    let index = 0
    for(const item of items) {
      index = index + 1
      if(items.length > index) {
        csv = csv + item + ','
      } else {
        csv = csv + item
      }
    }
    return csv
  }

}



// WEBPACK FOOTER //
// ./src/helpers/AppHelper.js